<style>

</style>

<template>
  <AppLayout class="events-component">
    <Row type="flex" justify="center">
      <Col :span="24">
        <SpecialProjectSingleComponent></SpecialProjectSingleComponent>
      </Col>
    </Row>
  </AppLayout>
</template>

<script>
  import SpecialProjectSingleComponent from '@/components/SpecialProjectSingleComponent'
  export default {
    name: 'EventsComponent',
    components: {
      SpecialProjectSingleComponent
    }
  }
</script>
